import React from "react";

import DicotomicCheckbox from "../dicotomic-checkbox/dicotomic-checkbox";
import { MascotasCoveragesTableContainer } from "./mascotas-coverages-table-style";
import { MascotasCoveragesTableProps, PetCoverage } from "./mascotas-coverages-table-types";
import { formatter } from "../../utils/utility";

const MascotasCoveragesTable = ({ coverages, insured, index }: MascotasCoveragesTableProps) => {
  const mainCoverages = coverages.filter((cov) => cov.required);
  const complementaryCoverages = coverages.filter((cov) => !cov.required);

  const obtenerCapital = (coverage: PetCoverage, required?: boolean): string => {
    const objCapital = insured.coverages.find((cov) => cov.code === coverage.code);
    if (required && (!objCapital || !objCapital.capital || objCapital.capital == 1)) return "";
    return objCapital ? formatter.format(Number(objCapital.capital)) : "0 €";
  };

  return (
    <MascotasCoveragesTableContainer className="bg-white">
      <div className="colSin-100 bg-snow">
        <div className="colSin-25 table-bgBlue padding-cabeceras borderB-white">
          Mascota {index + 1}
        </div>
      </div>
      <div className="colSin-50 borderR-white">
        <p className="table-bgBlue padding-cabeceras">GARANTÍAS OBLIGATORIAS</p>
        {mainCoverages.map((cov) => {
          return (
            <div className="coverage-row" key={cov.code}>
              <p className="padding-contenido">{cov.name}</p>
              <p className="main-money">{obtenerCapital(cov, true)}</p>
            </div>
          );
        })}
      </div>
      <div className="colSin-50">
        <p className="table-bgBlue padding-cabeceras">GARANTÍAS OPCIONALES</p>
        {complementaryCoverages.map((cov) => {
          return (
            <div className="coverage-row padding-cabeceras" key={cov.code}>
              <DicotomicCheckbox
                initChecked={insured.coverages.some((covSelect) => cov.code === covSelect.code)}
                className="mandatory"
                checkboxText={cov.name}
                onChange={() => {}}
              />
              <p className="money padding-contenido">{obtenerCapital(cov)}</p>
            </div>
          );
        })}
      </div>
    </MascotasCoveragesTableContainer>
  );
};

export default MascotasCoveragesTable;
